export default "/_next/static/images/c5d6aaaef7f69d0e04dffff8bf1e5c9d.jpg";